// extracted by mini-css-extract-plugin
module.exports = {"dialog":"PluginPlayerPage-module__dialog--2muaq","container":"PluginPlayerPage-module__container--2kR_5","plugin_player":"PluginPlayerPage-module__plugin_player--BNzy_"};